import React, { useRef, useState, useEffect } from 'react';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import axios from 'axios';
import Swal from 'sweetalert2';
function InvoiceDetails({
    jobId,
    applicantName,
    applicantAddress,
    applicantEmail,
    providerName,
    salary,
    currencyType,
    jobStartTime,
    jobTitle,
    jobEndTime,
    jobStartDate,
    jobEndDate,
    settlementPeriod,
    totalHours,
    totalSalary,
    submissionDate,
    invoiceNo,
    accountName,
    accountNumber,
    bankName,
    sortCode,
    ifscCode,
    invoiceStatus,
    isProvider = false,
    isFromInvoiceTab ,
    isRejected = false,
    isFromClockinModal = false,
    isApplicant,
    onClose = () => {},
}) {
    const invoiceRef = useRef();
    const [isDownloading, setIsDownloading] = useState(false);
    const [showRejectBox, setShowRejectBox] = useState(false);
    const [rejectionReason, setRejectionReason] = useState("");
    const [bankDetails, setBankDetails] = useState({
        accountName: '',
        accountNumber: '',
        bankName: '',
        sortCode: '',
        ifscCode: ''
    });
    const [userCountry, setUserCountry] = useState('');
    const [editableHours, setEditableHours] = useState(totalHours);
    const [isEditing, setIsEditing] = useState(false);
    const [checkoutUrl, setCheckoutUrl] = useState('');
    const [providerId, setProviderId] = useState(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const BOSTRIX_USER_ID = process.env.REACT_APP_BOSTRIX__USER_ID ;

    useEffect(() => {
        fetchBankDetails();
        fetchUserCountry();
        if(!isApplicant){
            fetchProviderDetails();
        }
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        console.log("Bank Details State:", bankDetails);
        console.log("IFSC Code from props:", ifscCode);
        console.log("User Country:", userCountry);
    }, [bankDetails, ifscCode, userCountry]);

    const fetchUserCountry = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );
            setUserCountry(response.data.data.address?.country?.name || '');
        } catch (err) {
            console.error('Error fetching user country:', err);
        }
    };

    const fetchBankDetails = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/api/get-bank-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );
            const data = response.data.data || {};
            console.log("Bank details API response:", data);
            console.log("IFSC Code from API:", data.ifscCode);
            
            setBankDetails({
                accountName: data.accountName || '',
                accountNumber: data.accountNumber || '',
                bankName: data.bankName || '',
                sortCode: data.sortCode || '',
                ifscCode: data.ifscCode || ''
            });
        } catch (err) {
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch bank details. Please try again.',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    
    const fetchProviderDetails = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/provider/get-provider-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );
            setProviderId(response.data.data.userId);
        } catch (err) {
            console.error('Error fetching provider details:', err);
        }
    };
    

    const calculateNewTotal = (hours) => {
        return (parseFloat(hours) * parseFloat(salary)).toFixed(2);
    };

    const handleHoursChange = (e) => {
        const newHours = e.target.value;
        setEditableHours(newHours);
   
    };

     // const formatDate = (dateString) => {
    //     const date = new Date(dateString);
    //     return date.toLocaleDateString('en-GB', {
    //         day: '2-digit',
    //         month: '2-digit',
    //         year: 'numeric',
    //     });

    const handleDownload = async () => {
        setIsDownloading(true);
        const ticketToken = sessionStorage.getItem('ticketToken');
        
        try {
            const response = await axios({
                url: `${process.env.REACT_APP_SERVER_URL}/api/generate-invoice-pdf`,
                method: 'POST',
                responseType: 'blob', // Important for receiving PDF data
                headers: {
                    Authorization: `Bearer ${ticketToken}`
                },
                data: {
                    jobId,
                    employeeName: applicantName,
                    employeeAddress: applicantAddress,
                    employeeEmail: applicantEmail,
                    employerName: providerName,
                    payrate: salary,
                    currencyType,
                    jobStartTime,
                    jobTitle,
                    jobEndTime,
                    jobStartedFrom: jobStartDate,
                    jobEndedOn: jobEndDate,
                    totalWorkingHours: totalHours,
                    totalAmountToBePayable: totalSalary,
                    SubmissionDate: submissionDate,
                    invoiceNo,
                    settlementPeriod,
                    accountName,
                    accountNumber,
                    bankName,
                    sortCode
                }
            });

            // Create blob from response
            const blob = new Blob([response.data], { type: 'application/pdf' });
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `invoice-${invoiceNo}.pdf`);
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setIsDownloading(false);
        } catch (error) {
            console.error('Error downloading PDF:', error);
            setIsDownloading(false);
            Swal.fire({
                icon: 'error',
                title: 'Download Failed',
                text: 'Failed to generate PDF. Please try again.',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    const handleSendForApproval = async() => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            // First, fetch the applicant's bank details
            const bankDetailsResponse = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            const bankDetails = bankDetailsResponse.data.data;
            const country = bankDetails.address?.country?.name || '';

            // Check if bank details exist based on country
            if (!bankDetails.accountName || !bankDetails.accountNumber || !bankDetails.bankName) {
                onClose();
                Swal.fire({
                    icon: 'error',
                    title: 'Missing Bank Details',
                    text: 'Please add your bank details before submitting the invoice.',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            // Check country-specific fields
            if (country === 'United Kingdom' && !bankDetails.sortCode) {
                onClose();
                Swal.fire({
                    icon: 'error',
                    title: 'Missing Sort Code',
                    text: 'Please add your sort code before submitting the invoice.',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            if (country === 'India' && !bankDetails.ifscCode) {
                onClose();
                Swal.fire({
                    icon: 'error',
                    title: 'Missing IFSC Code',
                    text: 'Please add your IFSC code before submitting the invoice.',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            // Create form data with both invoice and bank details
            // Use editableHours and calculated total if they've been modified
            const formData = {
                jobId: jobId,
                employeeName: applicantName,
                employeeAddress: applicantAddress,
                employeeEmail: applicantEmail,
                employerName: providerName,
                jobStartedFrom: jobStartDate,
                jobEndedOn: jobEndDate,
                totalWorkingHours: editableHours || totalHours, // Use edited hours if available
                settlementPeriod: settlementPeriod,
                payrate: salary,
                currencyType: currencyType,
                totalAmountToBePayable: calculateNewTotal(editableHours) || totalSalary, // Use calculated total if hours were edited
                jobStartTime: jobStartTime,
                jobTitle: jobTitle,
                jobEndTime: jobEndTime,
                invoiceStatus: 'submitted',
                SubmissionDate: new Date(),
                // Add bank details
                accountName: bankDetails.accountName || '',
                accountNumber: bankDetails.accountNumber || '',
                bankName: bankDetails.bankName || '',
                sortCode: bankDetails.sortCode || '',
                ifscCode: bankDetails.ifscCode || ''
            };

            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/applicant/save-invoice`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            onClose();
            if(response.status === 200) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    },
                    customClass: {
                        popup: 'swal-toast-custom'
                    }
                });

                Toast.fire({
                    icon: 'success',
                    title: 'Invoice sent for approval!'
                });
            }
        } catch(err) {
            onClose();
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to submit invoice. Please try again.',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    const handleResendForApproval = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/applicant/resend-invoice`,
                { invoiceNo },
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            onClose();
            if (response.status === 200) {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    },
                    customClass: {
                        popup: 'swal-toast-custom'
                    }
                });

                Toast.fire({
                    icon: 'success',
                    title: 'Invoice resent for approval!'
                });
            }
        } catch (err) {
            onClose();
            console.log(err);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to resend invoice. Please try again.',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };
const handleApproveInvoice = async() => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/approve-invoice`,{invoiceNumber: invoiceNo},{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
    })
    if(response.status === 200){
        console.log("response",response.data);
        Swal.fire({
            icon: 'success',
            title: 'Invoice approved successfully',
            position: 'center',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        })
        onClose();
    }
}

const handleRejectInvoice = async() => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/provider/reject-invoice`,{invoiceNumber: invoiceNo, rejectionReason: rejectionReason}, {
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
    })
    if(response.status === 200){
        console.log("response",response.data);
        Swal.fire({
            icon: 'success',
            title: 'Invoice rejected successfully',
            position: 'center',
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        })
        onClose();
    }
}

    let currencySymbol = "";

    if (currencyType === "INR") {
        currencySymbol = "₹";
    } else if (currencyType === "USD") {
        currencySymbol = "$";
    } else if (currencyType === "EUR") {
        currencySymbol = "€";
    } else if (currencyType === "GBP") {
        currencySymbol = "£";
    }

    const handleMakePayment = async () => {
        try {
            console.log('Starting payment process...');
            const webhookStatus = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/webhooks/status`
            );
            console.log('Webhook status response:', webhookStatus.data);

            // Create a Promise to handle the payment completion
            const paymentPromise = new Promise((resolve, reject) => {
                console.log('Setting up payment message handler...');
                
                // Setup message handler with timeout
                const messageHandler = (event) => {
                    console.log('Received postMessage event:', event);
                    if (event.data && event.data.type === 'payment_update') {
                        // Remove the event listener
                        window.removeEventListener('message', messageHandler);
                        console.log('Payment update received:', event.data);
                        
                        if (event.data.status === 'success') {
                            resolve(event.data);
                        } else {
                            reject(new Error(event.data.error || 'Payment failed'));
                        }
                    }
                };

                // Add event listener for postMessage
                window.addEventListener('message', messageHandler);
                console.log('Payment message handler setup complete');

                // Add timeout to reject promise if no response received
                setTimeout(() => {
                    window.removeEventListener('message', messageHandler);
                    reject(new Error('Payment timeout - no response received'));
                }, 300000); // 5 minute timeout
            });

            // Calculate total amount based on provider
            const finalAmount = shouldShowCurolynFee
                ? Math.round((parseFloat(totalSalary) + parseFloat(curolynFee)) * 100)
                : Math.round(parseFloat(totalSalary) * 100);

            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/merchant/create-payment`,
                {
                    amount: finalAmount,
                    currency: currencyType,
                    description: `Invoice ${invoiceNo} - ${jobTitle}`,
                    invoiceNo: invoiceNo,
                    accountName: accountName,
                    accountNumber: accountNumber,
                    bankName: bankName,
                    sortCode: sortCode
                }
            );

            console.log('Payment creation response:', response.data);

            if (response.data.checkout_url) {
                // Store payment tracking info
                sessionStorage.setItem('pendingPaymentInvoice', invoiceNo);
                sessionStorage.setItem('paymentOrderId', response.data.id);
                
                // Open payment window
                const paymentWindow = window.open(response.data.checkout_url, '_blank');
                if (!paymentWindow) {
                    throw new Error('Popup blocked - please allow popups for this site');
                }

                // Wait for payment completion message
                const paymentResult = await paymentPromise;
                
                // Show success message
                Swal.fire({
                    icon: 'success',
                    title: 'Payment Completed',
                    text: `Payment of ${paymentResult.amount} ${paymentResult.currency} has been processed successfully!`
                });
                
                onClose();
            }
        } catch (error) {
            console.error('Payment creation failed:', error);
            Swal.fire({
                icon: 'error',
                title: 'Payment Failed',
                text: error.message || 'Unable to process payment'
            });
        }
    };

    const handleMakePaymentDraft = async () => {
        try {
            const ticketToken = sessionStorage.getItem('ticketToken');
            if (!ticketToken) {
                throw new Error('No authentication token found');
            }

            
        // Calculate amount with 1% deduction
        console.log("totalSalary",totalSalary);
        const deduction = (parseFloat(totalSalary)) * 0.01;
        console.log("deduction",deduction);
        const finalAmount = Math.round((parseFloat(totalSalary) - deduction) );
        console.log("finalAmount////////////////////",finalAmount);

            // Create payment draft directly to applicant
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/merchant/create-payment-draft`,
                {
                    amount: finalAmount, // No Curolyn fee for this provider
                    currency: currencyType,
                    description: `Bostrix -Invoice ${invoiceNo} - ${jobTitle}`,
                    invoiceNo: invoiceNo,
                    accountName: accountName,
                    accountNumber: accountNumber,
                    bankName: bankName,
                    sortCode: sortCode
                },
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            if (response.status === 200) {
                Swal.fire({
                    icon: 'success',
                    title: 'Payment Draft Created',
                    text: 'Payment draft has been created successfully'
                });
            }
        } catch (error) {
            console.error('Payment draft creation failed:', error);
            Swal.fire({
                icon: 'error',
                title: 'Payment Failed',
                text: error.response?.data?.message || 'Unable to create payment draft'
            });
        }
    };

    // Calculate Curolyn Fee (5% of total salary)
    const curolynFee = (totalSalary * 0.05).toFixed(2);

    // Tax is initially set to 0
    const tax = 0.00;

    // Add this near the top of the component where other calculations are made
    const shouldShowCurolynFee = providerId !== BOSTRIX_USER_ID && isFromInvoiceTab;

    // Update the totalDue calculation
    const totalDue = shouldShowCurolynFee 
        ? (parseFloat(totalSalary) + parseFloat(curolynFee)).toFixed(2)
        : parseFloat(totalSalary).toFixed(2);

    const handleSubmitInvoice = async () => {
        const ticketToken = sessionStorage.getItem('ticketToken');
        try {
            // First, fetch the applicant's bank details
            const bankDetailsResponse = await axios.get(
                `${process.env.REACT_APP_SERVER_URL}/applicant/get-applicant-details`,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            const bankDetails = bankDetailsResponse.data.data;
            const userCountry = bankDetails.address?.country?.name || '';

            // Check if bank details exist
            if (!bankDetails.accountName || !bankDetails.accountNumber || !bankDetails.bankName) {
                onClose();
                Swal.fire({
                    icon: 'error',
                    title: 'Missing Bank Details',
                    text: 'Please add your bank details before submitting the invoice.',
                    timer: 3000,
                    showConfirmButton: false
                });
                return;
            }

            // Create the invoice data with the appropriate bank code based on country
            const invoiceData = {
                jobId: jobId,
                jobTitle: jobTitle,
                employeeName: applicantName,
                employeeAddress: applicantAddress,
                employeeEmail: applicantEmail,
                employerName: providerName,
                totalWorkingHours: totalHours,
                jobStartedFrom: jobStartDate,
                jobEndedOn: jobEndDate,
                jobStartTime: jobStartTime,
                jobEndTime: jobEndTime,
                currencyType: currencyType,
                payrate: salary,
                settlementPeriod: settlementPeriod,
                totalAmountToBePayable: totalSalary,
                SubmissionDate: new Date(),
                accountName: bankDetails.accountName,
                accountNumber: bankDetails.accountNumber,
                bankName: bankDetails.bankName,
                userCountry: userCountry,
                // Add the appropriate code based on country
                sortCode: userCountry === 'United Kingdom' ? bankDetails.sortCode : undefined,
                ifscCode: userCountry === 'India' ? bankDetails.ifscCode : undefined
            };

            // Submit the invoice
            const response = await axios.post(
                `${process.env.REACT_APP_SERVER_URL}/invoice/submit-invoice`,
                invoiceData,
                {
                    headers: {
                        Authorization: `Bearer ${ticketToken}`
                    }
                }
            );

            // Handle response
            if (response.status === 200) {
                onClose();
                Swal.fire({
                    icon: 'success',
                    title: 'Success',
                    text: 'Invoice submitted successfully!',
                    timer: 3000,
                    showConfirmButton: false
                });
            }
        } catch (error) {
            console.error('Error submitting invoice:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to submit invoice. Please try again.',
                timer: 3000,
                showConfirmButton: false
            });
        }
    };

    return (
        <div style={{ 
            padding: '5px',
            backgroundColor: 'white',
            maxWidth: windowWidth <= 480 ? '95%' : '800px',
            margin: '0 auto',
            width: '100%',
            boxSizing: 'border-box'
        }}>
            <div ref={invoiceRef} style={{
                position: 'relative',
                maxHeight: '600px',
                overflowY: 'auto',
                padding: '20px',
                borderRadius: '8px',
                fontFamily: 'Arial, sans-serif',
                backgroundColor: 'white',
                boxSizing: 'border-box'
            }}>
                <div style={{
                    position: 'absolute',
                    top: '60%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    fontSize: '70px',
                    color: 'rgba(0, 0, 0, 0.05)',
                    pointerEvents: 'none',
                    userSelect: 'none'
                }}>
                    CUROLYN
                </div>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    borderBottom: '2px solid #007bff',
                    paddingBottom: '10px',
                    marginBottom: '20px',
                    flexDirection: windowWidth <= 480 ? 'column' : 'row',
                    gap: '10px'
                }}>
                    <h2 style={{ 
                        margin: 0, 
                        color: '#007bff', 
                        fontSize: '28px',
                        textAlign: windowWidth <= 480 ? 'center' : 'left'
                    }}>CUROLYN</h2>

                    <div style={{ 
                        textAlign: windowWidth <= 480 ? 'center' : 'right',
                        width: '100%'
                    }}>
                        <p style={{ fontSize: '13px' }}><strong>Invoice No: {invoiceNo}</strong></p>
                        <p style={{ fontSize: '13px' }}><strong>Issued Date: {submissionDate}</strong></p>
                    </div>
                </div>
                <div style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                    
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px', gap: '20px', flexDirection: windowWidth <= 480 ? 'column' : 'row' }}>
                    <div style={{ flex: 1 }}>
                        <h3 style={{ 
                            fontSize: '12px', 
                            paddingBottom: '3px', 
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            fontWeight: 'normal'
                        }}><strong>BILLED TO</strong></h3>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>{applicantName}</p>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>{applicantAddress}</p>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>{applicantEmail}</p>
                    </div>

                    <div style={{ flex: 1 }}>
                        <h3 style={{ 
                            fontSize: '12px', 
                            paddingBottom: '3px', 
                            marginBottom: '8px',
                            textTransform: 'uppercase',
                            fontWeight: 'normal'
                        }}><strong>SERVICE DETAILS</strong></h3>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>Event name: {jobTitle}</p>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>Event date: {jobStartDate}</p>
                        <p style={{ fontSize: '12px', margin: '3px 0' }}>Time: {jobStartTime} to {jobEndTime}</p>
                    </div>
                </div>
                <div style={{ overflowX: 'auto', marginBottom: '20px' }}>
                    <table style={{ 
                        width: '100%',
                        borderCollapse: 'collapse',
                        fontSize: '12px'
                    }}>
                        <thead>
                            <tr>
                               
                                <th style={{ 
                                    textAlign: 'left', 
                                    padding: '10px', 
                                    borderBottom: '1px solid #000',
                                    fontSize: '12px',
                                    fontWeight: 'normal'
                                }}><strong>ITEM DESCRIPTION</strong></th>
                                <th style={{ 
                                    textAlign: 'right', 
                                    padding: '10px', 
                                    borderBottom: '1px solid #000',
                                    fontSize: '12px',
                                    fontWeight: 'normal'
                                }}><strong>HOUR</strong></th>
                                <th style={{ 
                                    textAlign: 'right', 
                                    padding: '10px', 
                                    borderBottom: '1px solid #000',
                                    fontSize: '12px',
                                    fontWeight: 'normal'
                                }}><strong>RATE</strong></th>
                                <th style={{ 
                                    textAlign: 'right', 
                                    padding: '10px', 
                                    borderBottom: '1px solid #000',
                                    fontSize: '12px',
                                    fontWeight: 'normal'
                                }}><strong>AMOUNT</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ padding: '6px', fontSize: '12px' }}>{jobTitle}</td>
                                <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '5px' }}>
                                    {isFromClockinModal ? (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    value={editableHours}
                                                    onChange={handleHoursChange}
                                                    style={{
                                                        width: '60px',
                                                        padding: '2px 5px',
                                                        marginRight: '5px',
                                                        fontSize: '12px'
                                                    }}
                                                />
                                            ) : (
                                                <span>{editableHours}</span>
                                            )}
                                            <button
                                                onClick={() => setIsEditing(!isEditing)}
                                                style={{
                                                    marginLeft: '5px',
                                                    padding: '1px 3px',
                                                    backgroundColor: isEditing ? '#4CAF50' : '#2196F3',
                                                    color: 'white',
                                                    border: 'none',
                                                    borderRadius: '3px',
                                                    cursor: 'pointer',
                                                    fontSize: '11px',
                                                    minWidth: '40px',
                                                    height: '20px'
                                                }}
                                            >
                                                {isEditing ? 'Save' : 'Edit'}
                                            </button>
                                        </div>
                                    ) : (
                                        <span>{totalHours}</span>
                                    )}
                                </td>
                                <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>{currencySymbol}{salary}</td>
                                <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>{currencySymbol}{calculateNewTotal(editableHours)}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'right', padding: '6px', fontSize: '12px', borderTop: '1px solid #000' }}>Subtotal</td>
                                <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px', borderTop: '1px solid #000' }}>{currencySymbol}{totalSalary}</td>
                            </tr>

                            {shouldShowCurolynFee && (
                                <>
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>Curolyn Fee</td>
                                        <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>{currencySymbol}{curolynFee}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="3" style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>VAT</td>
                                        <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px' }}>{tax}</td>
                                    </tr>
                                </>
                            )}
                            <tr>
                                <td colSpan="3" style={{ textAlign: 'right', padding: '6px', fontSize: '12px', borderTop: '1px solid #000' }}>Total Due</td>
                                <td style={{ textAlign: 'right', padding: '6px', fontSize: '12px', borderTop: '1px solid #000' }}>{currencySymbol}{totalDue}</td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <br/>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px', flexDirection: windowWidth <= 480 ? 'column' : 'row', gap: '15px' }}>
                    <div style={{ 
                        fontSize: '12px',
                        color: '#333',
                        textAlign: 'left'
                    }}>
                        <strong>Account Details:</strong>
                        
                        <div style={{ marginTop: '20px' }}>
                            <p>Account Name: {accountName || bankDetails.accountName}</p>
                            <p>Account Number: {accountNumber || bankDetails.accountNumber}</p>
                            <p>Bank Name: {bankName || bankDetails.bankName}</p>
                            
                            {(userCountry === 'United Kingdom' || sortCode || bankDetails.sortCode) && (
                                <p>Sort Code: {sortCode || bankDetails.sortCode}</p>
                            )}
                            
                            {(userCountry === 'India' || ifscCode || bankDetails.ifscCode) && (
                                <p>IFSC Code: {ifscCode || bankDetails.ifscCode}</p>
                            )}
                        </div>
                    </div>
                    <div style={{ 
                        fontSize: '12px',
                        color: '#333',
                        textAlign: 'center'
                    }}>
                        <strong>Terms and conditions:</strong>
                        <p>Payment is due {settlementPeriod} from the invoice date</p>
                    </div>
                </div>
            </div>

            <div style={{ textAlign: 'right', marginTop: '20px', display: 'flex', flexDirection: windowWidth <= 480 ? 'column' : 'row', gap: '10px', justifyContent: 'flex-end' }}>
                {!isDownloading && (
                    <>
                        {!isProvider && !isFromInvoiceTab && !isRejected && (
                            <>
                                <button onClick={handleDownload} style={{
                                    width: windowWidth <= 480 ? '100%' : '120px',
                                    padding: '10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>
                                    Download
                                </button>
                                {!submissionDate && (
                            <button onClick={handleSendForApproval} style={{
                                width: windowWidth <= 480 ? '100%' : '150px',
                                padding: '10px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                textAlign: 'center'
                            }}>
                                Send for Approval
                            </button>
                        )}

                        {invoiceStatus === 'rejected' && (
                            <button onClick={handleResendForApproval} style={{
                                width: windowWidth <= 480 ? '100%' : '180px',
                                padding: '10px',
                                backgroundColor: '#28a745',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px',
                                textAlign: 'center'
                            }}>
                                Resend for Approval
                            </button>
                        )}
                            </>
                        )}

                        {isProvider && !isFromInvoiceTab && !isFromInvoiceTab && !isRejected && (
                            <>
                                <button onClick={() => setShowRejectBox(!showRejectBox)} style={{
                                    width: windowWidth <= 480 ? '100%' : '150px',
                                    padding: '10px',
                                    backgroundColor: '#f87171',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>Reject</button>
                                <button onClick={handleApproveInvoice} style={{
                                    width: windowWidth <= 480 ? '100%' : '150px',
                                    padding: '10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>Approve</button>
                            </>
                        )}

                        {isFromInvoiceTab && (
                            <>
                                <button onClick={handleDownload} style={{
                                    width: windowWidth <= 480 ? '100%' : '120px',
                                    padding: '10px',
                                    backgroundColor: '#007bff',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '5px',
                                    cursor: 'pointer',
                                    fontSize: '16px',
                                    textAlign: 'center'
                                }}>
                                    Download
                                </button>
                                <button 
                                    onClick={providerId === BOSTRIX_USER_ID ? handleMakePaymentDraft : handleMakePayment}
                                    style={{
                                        width: windowWidth <= 480 ? '100%' : '150px',
                                        padding: '10px',
                                        backgroundColor: '#22c55e',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '5px',
                                        cursor: 'pointer',
                                        fontSize: '16px',
                                        textAlign: 'center'
                                    }}
                                >
                                        {providerId === BOSTRIX_USER_ID ? 'Create Payment Draft' : 'Make Payment'}
                                </button>
                            </>
                        )}
                    </>
                )}
            </div>

            {showRejectBox && (
                <div style={{ 
                    marginTop: '20px',
                    padding: '20px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                    backgroundColor: '#f9f9f9',
                    width: '100%',
                    boxSizing: 'border-box'
                }}>
                    <textarea
                        placeholder="Enter rejection reason"
                        value={rejectionReason}
                        onChange={(e) => setRejectionReason(e.target.value)}
                        style={{
                            width: '100%',
                            height: '100px',
                            padding: '10px',
                            borderRadius: '5px',
                            border: '1px solid #ccc',
                            marginBottom: '10px'
                        }}
                    />
                    <div style={{ textAlign: 'right' }}>
                        <button 
                            onClick={handleRejectInvoice} 
                            style={{
                                padding: '10px 20px',
                                backgroundColor: 'red',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                fontSize: '16px'
                            }}
                        >
                            Submit Rejection
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}

export default InvoiceDetails;